"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
/**
 * Registers a service worker with the given path.
 * 
 * @param swPath - The path to the service worker file relative to the root. Defaults to '/service-worker.js'.
 */
function register() {
  let swPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/service-worker.js';
  return new Promise(resolve => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      resolve('failed');
      return;
    }
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(swPath).then(registration => {
        console.log('[Service Worker] Registered with scope:', registration.scope);
        resolve('ready');
      }).catch(error => {
        console.error('[Service Worker] Registration failed:', error);
        resolve('failed');
      });
    });
  });
}